import React, { FC } from 'react';
import { SdkCodeSnippetsUncontrolled } from '@cld/sdk-code-snippets';
import { useParsedSnippets } from '../../../utils/useParsedSnippets';
import { useRecipeContentContext } from '../RecipeContentContext';

export interface CodeRendererProps {
  language: string;
  value: string;
}

export const CodeRenderer: FC<React.PropsWithChildren<CodeRendererProps>> = ({ value, language }) => {
  const { copyCallback } = useRecipeContentContext();
  const snippets = useParsedSnippets(value, language);

  return <SdkCodeSnippetsUncontrolled snippets={snippets} onCopy={copyCallback} />;
};
